import script from "./goRinSyo0065.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0065.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0065.vue?vue&type=style&index=0&id=e2b4b146&lang=scss"

const __exports__ = script;

export default __exports__